<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>

<vb-ui-typeahead-angular [typeaheadCfg]="searchTypeaheadCfg" (onSubmit)="submitMediaSearch($event.value)">
</vb-ui-typeahead-angular>
